import React, { useEffect, useState } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { connect } from "react-redux";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import ProspectdashboardPopup from "../prospectManagement/ProspectdashboardPopup";
const ProspectView = (props) => {
    const [dashboardmodalOpen,setdashboardmodalOpen]=useState(false)
const openprospectDashboardModal = () => async (e) => {
        e.preventDefault();
       
        
        setdashboardmodalOpen(true)
        
    }
const closeprospectDashboardModal= () => async (e) => {
    setdashboardmodalOpen(false)
}
 return (
    <>
    <span className="label-container eyeiconcalender">
    {props?.prospectName?.length>0 &&
                         <a  class="cursor-pointer" onClick={openprospectDashboardModal()}> <Tooltip
                        title="Click here to view prospect"
                        aria-label="Click here to view prospect"
                      ><RemoveRedEyeIcon /></Tooltip></a>
    }
           </span>
           {dashboardmodalOpen===true ?<ProspectdashboardPopup dashboardmodalOpen={dashboardmodalOpen} closeprospectDashboardModal={closeprospectDashboardModal()}  prospectName={props?.prospectName}/>:null}
           </>
  );
};



export default ProspectView;
